import React, { useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as pabReplanningAction from '../../../../actions/pabReplanningAction';
import { TitleUI } from '../../../../components/UI/LabelTitleUI';
import ListLinkBox from '../../../../components/UI/ListLinkBox';
import JustificationService from '../../../../services/JustificationService';
import { checkPermission } from '../../../../services/auth';
import { ENUMS, PERMISSIONS } from '../../../../utils/constants';
import { getPathApp, translate } from '../../../../utils/util';

const PABReplanning = (props) => {
    useEffect(() => {
        if (!props.justifications?.items || props.justifications?.items?.length === 0) {
            props.getJustifications(props.user.vision, {});
        }
        // eslint-disable-next-line
    }, []);

    const menu = () => {
        let menuItems = [];

        if (checkPermission(PERMISSIONS.Lowering.Access)) {
            menuItems = [...menuItems, {
                route: {
                    pathname: 'pabReplanning/smallparts',
                    state: { lowering: true }
                },
                icon: 'mdi mdi-camera-timer',
                text: translate('pab-replanning:pabReplanning:title')
            }];
        }

        if (checkPermission(PERMISSIONS.Lowering.ManageLowering)) {

            menuItems = [...menuItems, {
                route: {
                    pathname: `${getPathApp(window)}/pabReplanning/report`,
                },
                icon: 'mdi mdi-clipboard-list-outline',
                text: translate('lowering:lowering.report')
            }];

            menuItems = [...menuItems, {
                route: {
                    pathname: 'endCalls',
                    state: { orderType: ENUMS.eOrderType.Lowering.value }
                },
                icon: "mdi mdi-close-network-outline",
                text: translate('lowering:endCalls:end-calls-logistics')
            }];

            menuItems = [...menuItems, {
                route: {
                    pathname: 'pabReplanning/transmissions',
                    state: { type: ENUMS.eOrderType.PabReplanning.value }
                },
                icon: "mdi mdi-clipboard-list-outline",
                text: translate('expedition:picking.transmissions')
            }];
        }

        return menuItems;
    };

    return (
        <div>
            <div className="container-fluid h-65">
                <div className="row">
                    <TitleUI icon="mdi mdi-timetable" label={translate('menu:pabReplanning')} />
                </div>
            </div>
            <div className="container" style={{ marginLeft: '5px', marginTop: '40px', }}>
                <ListLinkBox
                    options={menu()}
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        justifications: state.justificationReducer.justifications,
        filter: state.pabReplanningReducer.filter
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getJustifications: (vision, filter, pagination) => {
            dispatch(JustificationService.getJustifications(vision, filter, pagination));
        },
        setFilterOrder: (filter) => {
            dispatch(pabReplanningAction.setFilter(filter));
        },
        clearOrders: () => {
            dispatch(pabReplanningAction.resetOrder());
            dispatch(pabReplanningAction.resetOrders());
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PABReplanning)));